import React, { useEffect } from "react";
import { Grid, Box } from "@chakra-ui/react";
import KGAnalysisPlan from "./KGPlan/KGAnalysisPlan";
import JobsContainer from "../../containers/batch/kg-analysis-plan/JobsContainer";
import StepsContainer from "../../containers/batch/kg-analysis-plan/StepsContainer";
import { useKGBatchContext } from "../../context/batch/KGBatchContext";
import JobRunContainer from "containers/batch/kg-analysis-plan/JobRunContainer";
import { useKGAnalysisPlanContext } from "context/batch/KGAnalysisPlanContext";
import { listMetrics } from "services/MetricService";

const AnalysisPlanPage: React.FC = () => {
  const { 
    showStepsContainer,
    showStatusPage, 
    selectedRunHeader, 
    setShowStatusPage, 
    setSelectedRunHeader,
    fetchJobHeaders
  } = useKGBatchContext();
  const { setMetricList } = useKGAnalysisPlanContext();

  // Fetch job headers when the component mounts
  useEffect(() => {
    fetchJobHeaders();
  }, []);

  useEffect(() => {
    const fetchMetrics = async () => {
      const metrics = await listMetrics("" /* Model ID */);
      setMetricList(metrics);
    };
    fetchMetrics();
  }, []);

  return (
    <Grid 
      templateColumns={showStepsContainer ? "1fr 1fr 5fr" : "1fr 6fr"} 
      templateRows="1fr" 
      height="100%" 
      gap={1} 
      bg="gray.100"
    >
      {/* Jobs Sidebar */}
      <Box bg="bg.surface" boxShadow="lg" borderRadius="lg" p={1} height="94vh">
        <JobsContainer />
      </Box>

      {/* Steps Sidebar - Only show if showStepsContainer is true */}
      {showStepsContainer && (
        <Box bg="bg.surface" boxShadow="lg" borderRadius="lg" p={1} height="94vh">
          <StepsContainer />
        </Box>
      )}

      {/* Main Content - Show either StatusPage or KGAnalysisPlan */}
      <Box bg="bg.surface" boxShadow="lg" borderRadius="lg" p={1} height="94vh" width="100%">
        {showStatusPage && selectedRunHeader ? (
          <JobRunContainer onBack={() => {
            setShowStatusPage(false);
            setSelectedRunHeader(null);
          }} />
        ) : (
          <KGAnalysisPlan />
        )}
      </Box>
    </Grid>
  );
};

export default AnalysisPlanPage;